<template>
    <modal
        :adaptive="true"
        :click-to-close="true"
        :scrollable="true"
        height="auto"
        width="400"
        name="contingency-modal"
        @closed="beforeOpen"
    >
        <div class="contingency-modal">
            <div class="contingency-modal__content">
                <div class="contingency-modal__close">
                    <img @click="closeModal" src="/images/icons/close-white.svg" alt="Close modal">
                </div>
                <div class="contingency-modal__body">
                    <template v-if="!successState">
                        <h2 class="contingency-modal__heading">
                            Due to COVID-19, our custom PC build service is currently suspended.
                        </h2>
                        <p class="contingency-modal__input__label">
                            Send me an email when BLD service resumes:
                        </p>
                        <div class="contingency-modal__input__error-container">
                            <span class="error text-danger">{{ errors.first('email') }}</span>
                            <span 
                                v-if="!email && !errors.first('email') && subscription" 
                                class="error text-danger">Invaild Email:</span>
                            <div class="contingency-modal__input__container">
                                <input
                                    type="text"
                                    class="contingency-modal__input"
                                    placeholder="your@email.com"
                                    v-model="email"
                                    name="email"
                                    v-validate="'required|email'"
                                >
                                <button
                                    @click.prevent="sendSubscription()"
                                    class="contingency-modal__input__button"
                                    :class="{ active: email }"
                                >
                                    <img src="/images/icons/right-arrow.svg" alt="">
                                </button>
                            </div>
                        </div>
                        <div class="contingency-modal__condition">
                            Your build will be saved and we’ll send you a reminder when we return.
                        </div>
                        <div class="contingency-modal__newsletter">
                            <label class="contingency-modal__newsletter__label">
                                <input
                                    v-model="subscription"
                                    type="checkbox"
                                    class="contingency-modal__newsletter__input"
                                >
                                <span />
                                Add me to the NZXT Newsletter
                            </label>
                        </div>
                        <div class="contingency-modal__separator">OR</div>
                    </template>
                    <div v-else class="contingency-modal__success-state">
                        <div>
                            <img src="/images/icons/orchid-check.svg" alt="">
                            <h2>Success</h2>
                        </div>
                        <p>
                            Your build has been saved and we’ll send you a reminder when we return.
                        </p>
                    </div>
                    <router-link
                        :to="{ name: 'home', hash: '#prebuild-section'}"
                        class="contingency-modal__prebuilds-btn btn"
                    >
                        Explore prebuilds
                    </router-link>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { Validator } from "vee-validate";
import { mapState } from "vuex";

const KLAVIYO_FIELDS = [
    "$source",
    "$email",
    "$bldnumber",
    "$subscription",
    "$consent_method",
    "$consent_form_id",
    "$consent_form_version"
];

export default {
    name: "ContingencyModal",
    data() {
        return {
            email: "",
            subscription: false,
            successState: false
        }
    },
    computed: {
        ...mapState({
            draftId: state => state.Step4.draftId
        })
    },
    mounted() {
        const dictionary = {
            en: {
                custom: {
                    email: {
                        email: "Invaild Email:",
                        required: "Invaild Email:"
                    }
                }
            }
        };

        Validator.localize(dictionary);
    },
    methods: {
        closeModal() {
            this.$modal.hide("contingency-modal");
        },
        beforeOpen() {
            this.successState = false;
            this.subscription = false;
        },
        async sendSubscription() {
            const isValid = await this.$validator.validateAll();

            if (!isValid) {
                return;
            }

            const formData = new FormData();
            formData.append("g", process.env.MIX_KLAVIYO_COVID_10);
            formData.append("$fields", KLAVIYO_FIELDS.join(","));
            formData.append("$email", this.email);
            formData.append("$bldnumber", this.draftId);

            axios({
                url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                method: "POST",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" }
            }).then(response => {
                this.successState = true;
                this.email= "";
                if (this.subscription) {
                    this.newsLetter();
                }
            });
        },
        async newsLetter() {
            const formData = new FormData();

            formData.append("g", process.env.MIX_KLAVIYO_BLD_NEWSLETTER);
            formData.append("$fields", KLAVIYO_FIELDS.join(","));
            formData.append("$email", this.email);

            axios({
                url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                method: "POST",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" }
            })
        }
    }
}
</script>

<style lang="scss">
.v--modal-overlay[data-modal="contingency-modal"] {
    background-color: rgba(0, 0, 0, 0.65);
    .v--modal-box {
        max-width: 100%;
    }
    .v--modal {
        box-shadow: none;
        background-color: #252525;
    }
    .modal-dialog {
        top: -130px;
        @media screen and (max-width: 680px) and (min-width: 320px) {
            top: -46px !important;
        }
    }
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";
.contingency-modal {
    border-radius: 2px;
    background-color: #252525;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.5);
    display: flex;
    color: $white;

    .error {
        display: block;
        font-size: 16px;
        text-align: left;
        margin: 0;
    }

    &__close {
        display: flex;
        justify-content: flex-end;
        img {
            margin-top: 15px;
            margin-right: 15px;
            cursor: pointer;
        }
    }

    &__content {
        text-align: center;
        width: 100%;
    }

    &__body {
        padding: 15px 35px 35px;

        @media (min-width: 320px) and (max-width: 480px) {
            padding: 15px 20px 25px;
        }
    }

    &__heading {
        font-family: Akkurat-Light;
        font-size: 24px;
        font-weight: 300;
        letter-spacing: 1.13px;
        line-height: 26px;
        margin: 0 0 25px;

        @media (min-width: 320px) and (max-width: 480px) {
            font-size: 22px;
        }
    }

    &__input__label {
        text-align: left;
        font-size: 15px;
        margin-bottom: 0;
    }

    &__input__error-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        margin-bottom: 10px;
        height: 80px;
    }
    &__input__container {
        display: flex;
    }
    &__input {
        height: 55px;
        border-radius: 2px;
        background-color: rgba(255,255,255,0.24);
        border: none;
        flex: 1;
        padding: 15px;
        font-size: 16px;
        &[aria-invalid="true"] {
            border: 2px solid #D0021B;
            transition: all .2s;
        }
    }
    &__input__button {
        margin-left: 15px;
        width: 55px;
        background-color: rgba(255,255,255,0.24);
        font-size: 28px;
        border-radius: 2px;
        outline: none;
        border: none;
        display: flex;
        justify-content: center;
    }
    &__condition {
        font-size: 14px;
        line-height: 21px;
        text-align: left;
        margin-bottom: 30px;
    }
    .text-danger {
        color: #D0021B;
        font-size: 14px;
    }

    &__newsletter {
        text-align: left;
        display: flex;
        margin-bottom: 25px;

        @media (min-width: 320px) and (max-width: 480px) {
            margin-bottom: 10px;
        }

        &__input {
            display: none;
        }

        &__label {
            display: flex;
            color: rgba(255,255,255,0.8);
            font-size: 14px;
            letter-spacing: 0;
            border-radius: 4px;
            cursor: pointer;
            font-weight: 300;
        }

        & span {
            width: 20px;
            height: 20px;
            display: block;
            background: transparent;
            border: solid 1px #8D29A0;
            margin-right: 7px;
            border-radius: 4px;
        }

        &__input:checked + span {
            background: #8D29A0;
            background-image: url("/images/icons/check-white.svg");
            background-size: 14px 11px;
            background-repeat: no-repeat;
            background-position: center;
        }
    }

    &__prebuilds-btn {
        width: 100%;
        background-color: #51007A;
        color: white;
        margin-top: 25px;

        @media (min-width: 320px) and (max-width: 480px) {
            margin-top: 15px;
        }

        &:hover {
            background: white;
            color: #51007A;
        }
    }

    &__success-state {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        padding: 55px 0;

        @media (min-width: 320px) and (max-width: 480px) {
            padding: 35px 0;
        }
        div {
            display: flex;
            margin-bottom: 40px;
        }
        h2 {
            margin: 0;
            text-transform: uppercase;
            font-size: 24px;
            font-weight: 300;
            letter-spacing: 1.13px;
            font-family: Akkurat-Light;
        }
        img {
            margin-right: 5px;
        }
        p {
            font-family: Akkurat-Light;
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 1.13px;
            line-height: 21px;
            margin-bottom: 20px;
        }
        p:last-child {
            margin-bottom: 60px;
        }
    }

    &__separator {
        text-align: center;
        position: relative;

        &::before,
        &::after {
            content: "";
            height: 1px;
            width: 50px;
            background: white;
            position: absolute;
            top: 43%;
            width: 43%;
        }

        &::before {
            left: 0;
        }

        &::after {
            right: 0;
        }
    }
}

.active {
    background-color: #BF4CBF !important;
}
</style>